import React from "react"
import {defineMessages, FormattedMessage} from "react-intl"
import Toggle from "react-toggle"
import {AppContext, Features} from "@lightspeed-invoicing/core-client/frontend"
import {PAYMENT_TYPE} from "../../state/helpers/Payment"

const messages = defineMessages({
    modal_integrated_payment_label: {
        id: "price_list.bulk.receive_payment.enable_integrated_payment_label",
        defaultMessage: "Use card on file",
    },
    modal_integrated_payment_bank_account_label: {
        id: "price_list.bulk.receive_payment.enable_integrated_payment_bank_account_label",
        defaultMessage: "Use bank account on file",
    },
    modal_integrated_payment_description: {
        id: "price_list.bulk.receive_payment.enable_integrated_payment_description_label",
        defaultMessage: "No payment will be taken if the contact doesn't have a card on file",
    },
    modal_integrated_payment_bank_account_description: {
        id: "price_list.bulk.receive_payment.enable_integrated_payment_bank_account_description_label",
        defaultMessage: "No payment will be taken if the contact doesn't have a bank account on file",
    },
})

type Props = {
    paymentType: string
    useDefaultCardOnFile: boolean,
    onIntegratedPaymentToggle: (useDefaultCardOnFile: boolean) => void,
}

const PaymentCalculationComponent = (props: Props) => {

    const accountHasIntegratedPayment = AppContext.hasFeatureIntegration(Features.IntegratedPayment)
    const accountHasIntegratedPaymentBankTransfer = AppContext.hasFeatureIntegration(Features.IntegratedPaymentBankTransfer)

    if ((accountHasIntegratedPayment && props.paymentType !== PAYMENT_TYPE.CREDIT_CARD)
        && (accountHasIntegratedPaymentBankTransfer && props.paymentType !== PAYMENT_TYPE.BANK_TRANSFER)) {
        return <></>
    }

    const getMessage = (paymentType: string) => {
        switch (paymentType) {
        case PAYMENT_TYPE.CREDIT_CARD:
            return <FormattedMessage{...messages.modal_integrated_payment_label}/>
        case PAYMENT_TYPE.BANK_TRANSFER:
            return <FormattedMessage{...messages.modal_integrated_payment_bank_account_label}/>
        default:
        }
    }

    const getMessageDescription = (paymentType: string) => {
        switch (paymentType) {
        case PAYMENT_TYPE.CREDIT_CARD:
            return <FormattedMessage{...messages.modal_integrated_payment_description}/>
        case PAYMENT_TYPE.BANK_TRANSFER:
            return <FormattedMessage{...messages.modal_integrated_payment_bank_account_description}/>
        default:
        }
    }

    return (
        <div className="form-group row mb-1 justify-content-end mt-2">
            <label className="col-4 col-form-label custom-form-label py-1 text-body text-right" htmlFor="amount">
                <div>
                    {getMessage(props.paymentType)}
                </div>

                <small className="form-text text-muted">
                    {getMessageDescription(props.paymentType)}
                </small>
            </label>
            <div className="col-3 d-flex align-items-center justify-content-end">
                <Toggle
                    defaultChecked={props.useDefaultCardOnFile}
                    icons={false}
                    onChange={() => {
                        props.onIntegratedPaymentToggle(!props.useDefaultCardOnFile)
                    }}/>
            </div>
        </div>

    )
}

PaymentCalculationComponent.defaultProps = {
    paymentType: "",
}

export default PaymentCalculationComponent


// WEBPACK FOOTER //
// ./src/payment/components/PaymentCalculationComponent.tsx